import { render } from "./TodosModal.vue?vue&type=template&id=c80c9840&scoped=true"
import script from "./TodosModal.vue?vue&type=script&lang=js"
export * from "./TodosModal.vue?vue&type=script&lang=js"

import "./TodosModal.vue?vue&type=style&index=0&id=c80c9840&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c80c9840"

export default script